var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("newLoginLog.BoxWrap.manage") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{pageName, list: ['LIST']}",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { size: "small", inline: "", "label-position": "top" },
                },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "row-bg",
                      attrs: { type: "flex", justify: "space-between" },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("newLoginLog.input.empNo"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "newLoginLog.input.inputHolder"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.empNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "empNo", $$v)
                                  },
                                  expression: "searchVal.empNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("newLoginLog.input.loginAccount"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "newLoginLog.input.inputHolder"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.loginCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "loginCode", $$v)
                                  },
                                  expression: "searchVal.loginCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("newLoginLog.input.loginInStyle"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "newLoginLog.input.optionHolder"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchVal.loginInStyle,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchVal,
                                        "loginInStyle",
                                        $$v
                                      )
                                    },
                                    expression: "searchVal.loginInStyle",
                                  },
                                },
                                _vm._l(
                                  _vm.lookupList["LOGINLOG_STATUS"],
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "row-bg",
                      attrs: { type: "flex", justify: "space-between" },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("newLoginLog.input.time"),
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  clearable: "",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: _vm.$t(
                                    "newLoginLog.input.timeHolder"
                                  ),
                                },
                                model: {
                                  value: _vm.searchVal.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "startTime", $$v)
                                  },
                                  expression: "searchVal.startTime",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "picker-line" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("el-date-picker", {
                                attrs: {
                                  clearable: "",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: _vm.$t(
                                    "newLoginLog.input.timeHolder"
                                  ),
                                },
                                model: {
                                  value: _vm.searchVal.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "endTime", $$v)
                                  },
                                  expression: "searchVal.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "header-bottom-right" }, [
            _c(
              "div",
              { staticClass: "header-bottom-right-btn" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["LIST"] },
                        expression: "{pageName, list: ['LIST']}",
                      },
                    ],
                    attrs: { size: "small", icon: "el-icon-refresh" },
                    on: { click: _vm.resetData },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.reset")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["LIST"] },
                        expression: "{pageName, list: ['LIST']}",
                      },
                    ],
                    staticClass: "t-search-btn",
                    attrs: { size: "small", icon: "el-icon-search" },
                    on: { click: _vm.searchData },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.search")))]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("newLoginLog.BoxWrap.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{pageName, list: ['EXPORT']}",
                      },
                    ],
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel(_vm.$t("newLoginLog.btn.exportText"))
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("newLoginLog.btn.export")))]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.tableIndex,
                  label: _vm.$t("newLoginLog.table.systemPk"),
                  width: "80",
                  align: "left",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t("newLoginLog.table.employeeNumber"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginCode",
                  label: _vm.$t("newLoginLog.table.username"),
                  width: "240",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginPlatform",
                  label: _vm.$t("newLoginLog.table.loginTerminal"),
                  width: "80",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginInDateTime",
                  label: _vm.$t("newLoginLog.table.loginTime"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginOutDateTime",
                  label: _vm.$t("newLoginLog.table.loginOutTime"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginInStyle",
                  label: _vm.$t("newLoginLog.table.status"),
                  width: "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.lookupList["LOGINLOG_STATUS_MAPPING"] &&
                                  _vm.lookupList["LOGINLOG_STATUS_MAPPING"][
                                    scope.row.loginInStyle
                                  ]) ||
                                  scope.row.loginInStyle
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }